import { AccountDTO } from '@common/contracts/server/modules/account/presentation/api/dto/index';

import type { FetcherAxiosInstance } from '../fetcher';

export const createAccountApi = (Fetcher: FetcherAxiosInstance) => ({

  getAccount(): Promise<AccountDTO> {
    return Fetcher.get('/account');
  },

  changePhone({ phone = '', token = '' }: { phone: string, token: string }) {
    return Fetcher.post('/account/phone', { phone, token });
  },

  accountExists: ({ type = 'phone', value, scanUnconfirmed = false }: {
    type: string,
    value: string,
    scanUnconfirmed: boolean,
  }) => {
    if (!value) {
      return Promise.reject('value is required');
    }

    return Fetcher.post('/account/exists', { type, value, scanUnconfirmed });
  },

  blockAccount({
    clientName,
    clientPhone,
    clientEmail,
    reason,
  }: {
    clientName: string,
    clientPhone: string | number,
    clientEmail: string,
    reason: string,
  }) {
    return Fetcher.post('account/block', {
      clientName,
      clientPhone,
      clientEmail,
      reason,
    });
  },

  fetchQrCode: () => Fetcher.get('account/qr-code'),
});

